
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/gardia-mci",
      function () {
        return require("private-next-pages/admin/gardia-mci.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/gardia-mci"])
      });
    }
  